import Link from "next/link";
import Image from "next/image";
import WordmarkLogo from "../public/logoSymbola_wordmark.png";
import BreadcrumbExtension, { Breadcrumb } from "./breadcrumbExtension";
import { ChatIcon, MailIcon, XIcon } from "@heroicons/react/outline";

interface WizardHeaderProps {
  helpModalOpen: boolean;
  setHelpModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  headline: string;
  blockLiveHelp: boolean;
  exitHref: string;
  breadcrumbs: Breadcrumb[];
  breadcrumbMobileBackLabel: string;
  breadcrumbMobileBackHref: string;
}

const WizardHeader: React.FC<WizardHeaderProps> = ({
  helpModalOpen,
  setHelpModalOpen,
  headline,
  blockLiveHelp,
  exitHref,
  breadcrumbs,
  breadcrumbMobileBackLabel,
  breadcrumbMobileBackHref,
}) => {
  const handleClick = () => {
    setHelpModalOpen(!helpModalOpen);
  };

  return (
    <div className="bg-white border-b w-screen shadow-sm ">
      <div className="  max-w-8xl mx-auto pr-1 sm:pr-2 pl-4 sm:pl-6 lg:pl-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link passHref href={exitHref || "/app"}>
                <a className="flex">
                  <Image
                    priority
                    width={140}
                    height={28.43}
                    src={WordmarkLogo}
                    alt="Logo"
                  />
                </a>
              </Link>
              <div className="hidden sm:block border-l text-gray-600 text-sm pl-4 ml-4">
                <p>{headline}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex-shrink-0">
              {!blockLiveHelp ? (
                <button
                  type="button"
                  className="relative inline-flex items-center px-4 py-2.5  text-sm font-medium rounded-md text-gray-600  hover:bg-gray-200 focus:outline-none  "
                  onClick={handleClick}
                >
                  <ChatIcon
                    className="-ml-1 mr-2 h-5 w-5 text-gray-600"
                    aria-hidden="true"
                  />
                  <span>Live help</span>
                </button>
              ) : (
                <a
                  className="relative inline-flex items-center px-4 py-2.5  text-sm font-medium rounded-md text-gray-600  hover:bg-gray-200 focus:outline-none  "
                  href="mailto:support@symbo.la"
                >
                  <MailIcon
                    className="-ml-1 mr-2 h-5 w-5 text-gray-600"
                    aria-hidden="true"
                  />
                  <span>Support</span>
                </a>
              )}
            </div>

            <>
              <div className="border-l my-8 w-0 h-6 mx-2"> </div>{" "}
              <button
                type="button"
                className=" relative inline-flex items-center px-2 mr-2 py-2  text-sm font-medium rounded-md text-gray-600  hover:bg-gray-200 focus:outline-none  "
              >
                {/* Default value only needed for pre-TypeScript conversion files.  As I migrate, exitHref is required prop. */}
                <Link href={exitHref || "/app"}>
                  <a>
                    <XIcon
                      className="block h-6 w-6 text-gray-400"
                      aria-hidden="true"
                    />
                  </a>
                </Link>
              </button>
            </>
          </div>
        </div>

        {breadcrumbs && breadcrumbs.length > 0 ? (
          <BreadcrumbExtension
            breadcrumbs={breadcrumbs}
            mobileBackHref={breadcrumbMobileBackHref}
            mobileBackLabel={breadcrumbMobileBackLabel}
          />
        ) : null}
      </div>
    </div>
  );
};
export default WizardHeader;
